import Vue from 'vue'
import VueRouter from 'vue-router'
const Home = () => import('../views/Home.vue')
const Page = () => import('../views/Page.vue')

const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error)
}
const routerReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
	return routerReplace.call(this, location).catch(error => error)
}
Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/page/:titleId',
		name: 'Page',
		component: Page
	},
	{
		path: '*',
		redirect: "/"
	},
]

const router = new VueRouter({
	routes
})

export default router